module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/how-works-mobile--pt.3b45e87a.svg";